import { z } from 'zod';
/**
 * BILDIRGINING HOLATLARI — qoldiqda yo'q mahsulot uchun arizaning umri.
 *
 * `DRAFT` ataylab YO'Q (rasxod akti bilan ayni sabab): bildirgi bitta oynada
 * to'ldiriladi va o'sha yerdan yuboriladi. Yarim to'ldirilgani saqlansa,
 * u navbatga tushmasdan yotib qolardi va xodim «men so'ragan edim-ku» deb
 * o'ylab yurardi.
 *
 * Tartib oqim bo'yicha: `SUBMITTED` dan `FULFILLED` gacha asosiy yo'l,
 * oxirida ikki tugash holati. Ro'yxatning O'ZI o'tishlarni belgilamaydi —
 * kimdan kimga o'tish mumkinligini faqat domen biladi
 * (`apps/api/src/contexts/backorder/domain/backorder.ts`).
 */
export const BACKORDER_STATUSES = [
    'SUBMITTED',
    'ACCEPTED',
    'FULFILLED',
    'REJECTED',
    'CANCELLED',
];
export const backorderStatusSchema = z.enum(BACKORDER_STATUSES);
export const isBackorderStatus = (value) => BACKORDER_STATUSES.includes(value);
const BACKORDER_STATUS_LABELS = {
    SUBMITTED: 'Yuborilgan',
    ACCEPTED: 'Sklad qabul qildi',
    FULFILLED: 'Biriktirildi',
    REJECTED: 'Rad etilgan',
    CANCELLED: 'Bekor qilingan',
};
/**
 * Holatning o'zbekcha yorliqi.
 *
 * Nomi `statusLabel` emas: shartnoma paketi bitta barrel (`index.ts`) orqali
 * chiqadi va umumiy nom boshqa kontekst bilan to'qnashardi
 * (`requisitionStatusLabel`, `unitLabel` bilan bir uslub).
 */
export const backorderStatusLabel = (status) => BACKORDER_STATUS_LABELS[status];
/** Yakuniy holatlar — bulardan keyin bildirgi o'zgarmaydi. */
export const TERMINAL_BACKORDER_STATUSES = ['FULFILLED', 'REJECTED', 'CANCELLED'];
export const isTerminalBackorderStatus = (status) => TERMINAL_BACKORDER_STATUSES.includes(status);
//# sourceMappingURL=status.js.map